import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBasePortal } from './base';

/**
 * @internal
 */
export class ApiPortalCustomer extends ApiBasePortal {
  @ApiOptions({ channel: 'customerMeGet', reloadIgnore: true })
  getUserProfile() {
    return this.get(`/customer-v2.52/me`);
  }

  @ApiOptions({ channel: 'customerMeModify' })
  editUserProfile(params: ParamsAdapter) {
    return this.patch(`/customer-v2.52/me`, params);
  }
}
